import React from 'react';

import {ScrollArea} from '@/components/ScrollArea/ScrollArea';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import DeviceImage from '@/views/DeviceImage/DeviceImage';

import DeviceLock from '../../../DeviceSettings/views/DeviceLock/DeviceLock';
import {useDeviceLockVisibility} from '../../../DeviceSettings/views/DeviceLock/useDeviceLockVisibility';
import MyDevicesConnectButton from '../MyDevicesConnectButton/MyDevicesConnectButton';
import MyDevicesGoToChromeMessage from '../MyDevicesConnectButton/MyDevicesGoToChromeMessage';
import {useConnectionFlow} from '../MyDevicesConnectButton/useConnectionFlow';
import MyDevicesDeviceHeader from '../MyDevicesDeviceHeader';

const MyDevicesImageSection = ({device, deviceName}) => {
    const isDesktopLayout = useIsDesktopLayout();
    const {showDownloadChromeButton, showConnectButton} = useConnectionFlow();
    const isDeviceLockVisible = useDeviceLockVisibility();

    const content = (
        <>
            <MyDevicesDeviceHeader deviceName={deviceName} />
            {isDesktopLayout && showConnectButton && <MyDevicesConnectButton />}
            {isDesktopLayout && isDeviceLockVisible && <DeviceLock className='mt-2' />}
            {showDownloadChromeButton && isDesktopLayout && <MyDevicesGoToChromeMessage />}
            <DeviceImage
                className='relative mx-auto mb-8 mt-8 aspect-square w-full max-w-[298px] md:max-w-[398px] ml:mb-0 ml:aspect-auto ml:h-full ml:max-w-none'
                device={device}
                holder={device?.holder}
                imgClassName='max-h-[298px] md:max-h-[398px] top-0 absolute ml:max-h-none ml:w-auto ml:h-full ml:object-contain ml:min-h-[200px] ml:left-1/2 ml:-translate-x-1/2 object-top'
                ignoreRestrictedMarket
                showHolder
            />
            {showDownloadChromeButton && !isDesktopLayout && <MyDevicesGoToChromeMessage />}
        </>
    );

    return isDesktopLayout ? (
        <ScrollArea
            className='flex w-full max-w-[572px] flex-1 flex-col overflow-hidden px-0 pt-8'
            viewportClassName='[&>div]:h-full [&>div]:table-fixed'
        >
            <div className='table-row h-full'>
                <div className='flex h-full flex-col'>{content}</div>
            </div>
        </ScrollArea>
    ) : (
        <section className='flex w-full flex-col px-4 md:px-8'>{content}</section>
    );
};

export default MyDevicesImageSection;
